module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-fluid p-grid"
  }, [_c('div', {
    staticClass: "p-col-12 p-md-6"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36dd2300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/graphReport/purchaseSalesGraph.vue
// module id = 2148
// module chunks = 0